module.exports = __webpack_public_path__ + "img/attendance_congrats.8aee170.jpeg";